module.exports = __webpack_public_path__ + "img/other_books.1b4c900c.png";